module.exports = __webpack_public_path__ + "img/sample23.6b9ede15.jpg";